import cntl from "cntl";
import { Badge } from ".";
import PropTypes from "prop-types";
import { SIZE } from "../constants";
import { useMemo, useState } from "react";
import { getBadgeColors } from "@dbox/core/utils/getBadgeColors";

const propTypes = {
  label: PropTypes.string,
  isOutline: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.oneOf([SIZE.sm, SIZE.md, SIZE.lg]),
};

function BadgeDot({ label, size, className, isOutline }) {
  const [padding, setPadding] = useState("");

  const badgeColors = useMemo(() => getBadgeColors(label), [label]);

  const colorsFilled = () => cntl`
    ${badgeColors?.backgroundColor}
  `;

  const colorsOutline = () => cntl`
    outline
    bg-white
    outline-[1.5px]
    outline-offset-[-1.5px]
    ${badgeColors?.bordersColor}
  `;

  const colors = () => cntl`
    ${badgeColors?.textColor}
    ${isOutline ? colorsOutline() : colorsFilled()}
  `;

  const badgeDotCn = () => cntl`
    gap-x-1.5
    rounded-2xl
    ${padding}
    ${colors()}
    ${className ? className : undefined}
  `;

  const dotCn = () => cntl`
    w-1.5
    h-1.5
    rounded-full
    ${badgeColors?.iconDotColor}
  `;

  useMemo(() => {
    switch (size) {
      case SIZE.sm:
        setPadding("pl-1.5 pr-2");
        break;
      case SIZE.md:
        setPadding("pl-2 pr-2.5");
        break;
      case SIZE.lg:
        setPadding("pl-2.5 pr-3");
        break;
      default:
        setPadding("pl-1.5 pr-2");
        break;
    }
  }, [size]);

  return (
    <Badge className={badgeDotCn()} label={label} size={size}>
      <div className={dotCn()} />
    </Badge>
  );
}

BadgeDot.propTypes = propTypes;
export default BadgeDot;
